import {
  string as yupString,
} from 'yup';

import InputFormik from '../../../shared/forms/input/inputFormik.component';
import SelectFormik from '../../../shared/forms/select/sdkSelectFormik.component';
import { maxLength, required } from '../../../shared/forms/validators';
import { hideField } from '../../../shared/forms/constants';

import EditCurrencyCodeModalAlert from './editCurrencyCodeModalAlert.component';

const schema = [
  {
    name: 'countryCode',
    component: InputFormik,
    meta: { label: 'Country Code' },
    options: { yupType: yupString(), disabledWhenEditing: true, validationRules: [required, maxLength(2)] },
    additionalProps: { required: true },
  },
  {
    name: 'countryName',
    component: InputFormik,
    meta: { label: 'Country Name' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'currencyCode',
    component: SelectFormik,
    meta: { label: 'Currency Code', optionsKey: 'currencyCodeOptions' },
    options: { yupType: yupString(), validationRules: [required] },
    additionalProps: { required: true },
  },
  {
    name: 'editCurrencyCodeWarning',
    component: EditCurrencyCodeModalAlert,
    options: { readOnly: true },
    conditions: [
      {
        when: ({ formik, formContext }: any) => !formContext.openForEdit || !formik.touched.currencyCode,
        then: hideField,
      },
    ],
  },
];

export default schema;
